export enum SortType {
    No = "0",
    Yes = "1",
    PartiallyOn = "2"
}